module.exports = __webpack_public_path__ + "static/img/head_1.afc17507.png";